import { useDispatch, useSelector } from 'react-redux';
import { add, clear, remove } from '../redux/slices/notificationSlice';

export default function useNotifications() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.notifications);

  const notify = (notification, options = {}) => {
    if (typeof notification === 'string') {
      notification = { content: notification, localize: true, ...options };
    }
    dispatch(add({
      ...notification,
      timeout: notification.timeout != null ? notification.timeout : 5,
      variant: notification.variant != null ? notification.variant : 'success'
    }));
  };

  return {
    notify,
    add: ({ id, content, localize, icon, timeout, variant }) => {
      return dispatch(add({ id, content, localize, icon, timeout, variant }));
    },
    remove: (id) => dispatch(remove(id)),
    clear: () => dispatch(clear()),
    data: state
  };
}
